import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import ContactForm from '@/pages/contact/components/ContactForm';

const contactItems = [
  { icon: 'ri-mail-line', label: '邮箱', value: 'service@shenmatv.com', desc: '反馈与合作洽谈' },
  { icon: 'ri-phone-line', label: '客服电话', value: '400-888-6666', desc: '工作日 9:00 - 18:00' },
  { icon: 'ri-map-pin-line', label: '公司地址', value: '北京市朝阳区影视文化产业园 B 座 12 层', desc: '欢迎来访交流' },
];

const socialItems = [
  { icon: 'ri-wechat-line', label: '微信公众号' },
  { icon: 'ri-weibo-line', label: '新浪微博' },
  { icon: 'ri-bilibili-line', label: '哔哩哔哩' },
  { icon: 'ri-youtube-line', label: 'YouTube' },
];

export default function ContactPage() {
  useDocumentMeta({
    title: '联系我们 - 神马影院',
    description: '联系神马影院：通过邮箱、客服电话或意见反馈表单与我们取得联系，反馈影视资源建议、内容纠错或合作意向。',
    keywords: '联系神马影院,神马影院反馈,神马影院客服,影视资源反馈',
    path: '/contact',
  });

  return (
    <div className="mx-auto max-w-[1400px] px-4 py-8 md:px-6 md:py-12">
      <div className="max-w-2xl">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
          <i className="ri-customer-service-2-line"></i> 联系我们
        </span>
        <h1 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">随时与我们保持联系</h1>
        <p className="mt-3 text-sm leading-relaxed text-foreground-500 md:text-base">
          无论你是想推荐一部好剧、反馈内容问题，还是希望与我们合作，神马影院都欢迎你的声音。我们会认真阅读每一条留言。
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.1fr]">
        <div className="space-y-6">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {contactItems.map((item) => (
              <div key={item.label} className="rounded-xl border border-background-200 bg-background-50 p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-600 text-background-50">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <p className="mt-3 text-xs font-medium uppercase tracking-wider text-foreground-400">{item.label}</p>
                <p className="mt-1 text-sm font-semibold text-foreground-900">{item.value}</p>
                <p className="mt-0.5 text-xs text-foreground-500">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="rounded-xl border border-background-200 bg-background-50 p-5">
            <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-share-line text-accent-500"></i> 关注我们
            </h2>
            <div className="mt-4 flex flex-wrap gap-3">
              {socialItems.map((item) => (
                <span
                  key={item.label}
                  className="flex cursor-pointer items-center gap-2 rounded-full bg-background-100 px-4 py-2 text-sm text-foreground-600 transition-colors hover:bg-accent-500 hover:text-background-50"
                >
                  <i className={`${item.icon} text-lg`}></i> {item.label}
                </span>
              ))}
            </div>
          </div>

          <div className="overflow-hidden rounded-xl border border-background-200">
            <iframe
              title="神马影院办公地点地图"
              aria-label="神马影院办公地点地图"
              src="https://www.google.com/maps?q=Beijing%20Chaoyang%20Cultural%20Industry%20Park&output=embed"
              className="h-56 w-full border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        <ContactForm />
      </div>
    </div>
  );
}